<template>
  <div class="min-vh-100">
    <div class="p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">CUSTOMER DETAILS</h1>
    </div>
    <div class="mt-3 bg-white-border p-3 main-theme">
      <b-row class="mb-4">
        <b-col md="3">
          <b-img
            :src="profile.imgUrl"
            v-bind="{
              blank: true,
            }"
            blank-color="#8a93a2"
            class="img-customer"
            rounded="circle"
            center
          />
        </b-col>
        <b-col md="9">
          <p class="txt-title">
            First Name: <span>{{ profile.firstName }} </span>
          </p>
          <p class="txt-title">
            Last Name: <span>{{ profile.lastName }} </span>
          </p>
          <p class="txt-title">
            Email: <span>{{ profile.email }} </span>
          </p>
          <p class="txt-title mb-0">
            Registed Date:
            <span>
              {{ new Date(profile.registedDateTime) | moment($formatDateTime) }}
            </span>
          </p>
        </b-col>
      </b-row>
      <hr />
      <b-tabs content-class="m-0" v-model="tabIndex">
        <!-- <b-tab title="System Field">
          <TableList
            ref="systemFieldList"
            title="EDIT SYSTEM FIELD"
            type="SystemField"
            :userGUID="userGUID"
            @handleSuccess="handleSuccess"
            @handleFail="handleFail"
          />
        </b-tab> -->
        <b-tab title="Custom Field">
          <TableList
            ref="customFieldList"
            title="EDIT CUSTOM FIELD"
            type="CustomField"
            :userGUID="userGUID"
            @handleSuccess="handleSuccess"
            @handleFail="handleFail"
          />
        </b-tab>
      </b-tabs>
      <b-row class="mt-3">
        <b-col class="text-sm-left">
          <router-link to="/customer">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5"
              >CANCEL</b-button
            >
          </router-link>
        </b-col>
      </b-row>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import TableList from "./components/TableList.vue";
export default {
  name: "CustomerDetails",
  components: {
    ModalAlert,
    ModalAlertError,
    TableList,
  },
  data: function() {
    return {
      userGUID: this.$route.params.id,
      search: "",
      profile: {
        firstName: "",
        lastName: "",
        email: "",
        registedDateTime: null,
        lastUpdatedDateTime: null,
        userGUID: "",
        imageUrl: "",
      },
      modalMessage: "",
      tabIndex: 0,
    };
  },
  created: async function() {
    await this.getProfile();
  },
  methods: {
    getProfile: async function() {
      this.isBusy = true;
      let body = {
        userGUID: this.userGUID
      }
      await this.axios
        .post(`${this.$baseUrl}/Customer/Detail`, body)
        .then((data) => {
          if (data.result == 1) {
            this.profile = data.detail;
          } else this.handleFail(data.message);
        })
      this.isBusy = false;
    },
    async hadleModalAlertClose() {
      this.$refs.modalAlert.hide();
    },
    async handleSuccess(msg = false) {
      this.modalMessage = msg || "Success";
      this.$refs.modalAlert.show();
    },
    async handleFail(msg = false) {
      this.modalMessage = msg || "Fail";
      this.$refs.modalAlertError.show();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .main-theme .nav-tabs .nav-link {
  border-left: 0;
}

.create-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #5b57a5;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
}
.img-customer {
  width: 150px;
  height: 150px;
}
</style>
